/**
 * Shared "How did you hear about this event?" option helpers.
 *
 * Single source of truth for the safe generic default list and the normalization
 * guest-side logic. Hosts can override per-event via event.source_options and
 * save to host_defaults.source_options.
 *
 * Safe generic defaults — intentionally domain-neutral. LS-specific options
 * (FetLife, SLS, Kasidie, Telegram) are NEVER included by default and must be
 * opted-in by the host.
 */

export const SAFE_DEFAULT_SOURCE_OPTIONS = [
  'Friend',
  'Social Media',
  'Website',
  'Email / Newsletter',
  'Flyer / QR Code',
  'Other',
];

/**
 * Returns the display-ready list for a guest dropdown. Prefers event.source_options
 * when configured; falls back to the safe defaults. Always guarantees "Other" exists.
 */
export function resolveSourceOptions(event) {
  const configured = event?.source_options;
  const base = Array.isArray(configured) && configured.length > 0
    ? configured
    : SAFE_DEFAULT_SOURCE_OPTIONS;
  // Ensure "Other" is present and placed last (defensive — server normalizes too).
  const withoutOther = base.filter((o) => typeof o === 'string' && o.trim() && o.toLowerCase() !== 'other');
  return [...withoutOther, 'Other'];
}
